import useMountEffect from '@restart/hooks/useMountEffect';
import React, { useState } from 'react';

import Window from './Window';

const Windows = () => {
  const [windows, setWindows] = useState([]);

  useMountEffect(() => {
    windowsManager.setWindowsState(setWindows);

    return () => {
      windowsManager.setWindowsState(null);
    };
  });

  const close = (id) => {
    windowsManager.hide(id);
  };

  return (
    <>
      {windows.map(({ id, component: Component, config, props }) => {
        const { title, color } = config;

        return (
          <Window key={id} title={title} color={color} onClose={() => close(id)}>
            <Component {...props} />
          </Window>
        );
      })}
    </>
  );
};

export default Windows;

const windowsManager = {
  _setWindowsState: null,

  setWindowsState(setState) {
    this._setWindowsState = setState;
  },

  show(component, id, config = {}, props = {}) {
    const window = { id, component, config, props };

    this._setWindowsState((prev) => {
      // 동일한 id의 윈도우가 이미 있으면 추가하지 않음
      if (prev.some((window) => window.id === id)) {
        return prev;
      }
      return [...prev, window];
    });
  },

  hide(id) {
    this._setWindowsState((prev) => prev.filter((window) => window.id !== id));
  },
};

export { windowsManager };
